
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircleIcon } from "lucide-react";

interface PayPalErrorAlertProps {
  errorMessage: string;
  onShowDetailedError: () => void;
  setErrorDetails: () => void;
}

export const PayPalErrorAlert = ({ errorMessage, onShowDetailedError, setErrorDetails }: PayPalErrorAlertProps) => {
  const handleShowDetails = () => {
    setErrorDetails();
    onShowDetailedError();
  };

  return (
    <Alert variant="destructive" className="mb-8 max-w-3xl mx-auto">
      <AlertCircleIcon className="h-4 w-4" />
      <AlertTitle>PayPal Subscription Error</AlertTitle>
      <AlertDescription>
        <p>{errorMessage}</p>
        <button 
          onClick={handleShowDetails}
          className="mt-2 text-blue-600 hover:underline font-medium"
        >
          Show technical details
        </button>
      </AlertDescription>
    </Alert>
  );
};
